<template>
    <div>
        <div class="header">
            <div class="line"></div>
            <div class="title">{{name}}</div>
            <div class="line"></div>
        </div>
        <div class="item">
            <div class="list" v-for="item in list" :key="item.id" @click="jump(item.id,item.cate_name)">
                <div class="img"><img :src="item.pic" alt=""></div>
                <div>{{item.cate_name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getFlowerList } from "@api/table";
export default {
    data(){
        return{
            list:[],
            name:''
        }
    },

    mounted(){
        this.getFlowerList();
    },

    methods:{
        getFlowerList(){
            getFlowerList().then(res=>{
                this.list = res.data.item
                this.name = res.data.name.cate_name
            })
        },

        jump(e,name){
            this.$router.push('/goods_list?id=' + e +'&title=' + name);
        }
    }
}
</script>

<style scoped>
.header{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.line{
    width: 100px;
    height: 0.4px;
    background-color: #999;
}

.title{
    padding: 10px 10px;
}

.item{
    display: flex;
    flex-wrap: wrap;
    padding: 0 2px 0 10px;
}

.list{
    width: 23%;
    height: 150px;
    margin-right: 7px;
}

.list div:last-child{
    text-align: center;
    font-size: 13px;
    margin-top: 4px;
}

.img{
    width: 100%;
    height: 69%;
}

.img img{
    width: 100%;
    height: 100%;
}
</style>